import React, { FC } from "react";

interface Props {
	text: string;
	type?: "semi" | "dark";
}

const QuantityCircle: FC<Props> = ({ text, type }) => {
	return (
		<div className="d-flex align-items-center">
			<div className={`quantity-circle ${type ? type : ""}`}></div>
			<p className="mb-0">{text}</p>
		</div>
	);
};

export default QuantityCircle;
